import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { Logo } from './Logo';
import { COLOR_ACCENT, COLOR_BASE } from './colors';

const buttonAppear = keyframes`
  from {
    max-height: 0;
    opacity: .25;
    transform: scale(0);
  }
  50% {
    max-height: 0;
    opacity: .25;
    transform: scale(0);
  }
  95% {
    transform: scale(1.1);
  }
  to {
    transform: scale(1);
    max-height: 100px;
    opacity: 1;
  }
`;
export const AddButton = styled.button<{
  'data-noanim'?: boolean;
}>`
    width: 100%;
    border: 0;
    margin: 0;
    min-height: 50px;
    background-color: ${COLOR_ACCENT};
    animation: ${buttonAppear} ${props => props['data-noanim'] ? '0' : '1.4s'};
    font-family: 'OutlineEmoji';
    font-size: 1.5rem;
    line-height: 2.5rem;
    border-radius: 0 0 1rem 1rem;
    overflow: hidden;
    border-bottom: .15rem solid ${COLOR_BASE};
    font-family: 'PT Serif', serif;
    color: ${COLOR_BASE};
    :active {
      transform: translateY(.15rem);
      border-bottom: 1px solid ${COLOR_BASE};
    }
    > svg {
      transform: translateY(.4rem);
      fill: ${COLOR_BASE};
    }
`;
AddButton.defaultProps = {
    children: (
      <Logo height="2rem" />
    )
};
